import React from 'react';
import PropTypes from 'prop-types';

import ScreenSizes from '../../screen_sizes';

import DropdownButton from '../../realize_overrides/components/dropdown/dropdown_button.jsx';
import ButtonGroup from '../../realize_overrides/components/button/button_group.jsx';

import { FormEvents, FormEventHandler, FormElements } from '../../form/events/form_event_handler';
import { ActivityFormEventHandler, ActivityFormEvents } from '../../process/events/activity_form_event_handler';

import { ProcessActions } from '../reflux/process_store';
import { ProcessAPI } from 'lecom-api';

import {approveForm, rejectForm} from '../../bpm_integration/multiple_complete_activity_action'

export default class ActivityToolboxActionGroup extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			resize: false,
			winparent: false
		};
	}

	static propTypes = {
		processIds: PropTypes.object,
		processDefinitionIds: PropTypes.object,
		waitingForAction: PropTypes.bool,
		readOnly: PropTypes.bool,
		existHelpFile: PropTypes.bool,
		isMobile: PropTypes.bool,
	};

	static defaultProps = {
		processIds: {},
		processDefinitionIds: {},
		waitingForAction: false,
		readOnly: false,
		isMobile: false
	};

	componentDidMount() {
		let windowParent = false;

		try{
			window.parent.window.innerWidth
		}catch(e){
			windowParent = true;
		}

		this.setState({ resize: false, winparent: windowParent });

		window.addEventListener("message", this.receiveActions.bind(this));

		if(!windowParent)
			window.addEventListener("resize", this.resize.bind(this));
	}

	componentWillUnmount() {
		window.removeEventListener("message", this.receiveActions.bind(this));
		window.removeEventListener("resize", this.resize.bind(this));
	}

	resize() {
		const isMobile = this.detectMobWidth();		

		if(isMobile && !this.state.resize){
			this.setState({resize: true});
			this.forceUpdate();
		}else if(!isMobile && this.state.resize){
			this.setState({resize: false});
			this.forceUpdate();
		}
	}

	receiveActions(e) {
		const reveiveData = e.data;
		
		if(reveiveData.event === 'ACTION_HEADER')
			this.executeToolboxAction(reveiveData.actionName);
		else if (reveiveData === 'MULTIPLE_APPROVAL'){
			approveForm();
		}else if (reveiveData === 'MULTIPLE_REJECTION'){
			rejectForm();
		}else if (reveiveData.event === 'WIN_RESIZE'){
			//{event:"WIN_RESIZEL", width: 850}
			this.setState({width: reveiveData.width}, ()=>{
				this.forceUpdate();
			});			
		}
	}

	executeToolboxAction(actionName) {
		//TODO: Usar a ProcessAPI para executar a action
		const isMobile = this.props.isMobile;

		if(isMobile === true)
			event.preventDefault();

		const processApi = ProcessAPI.process(this.props.processIds);
		ProcessActions[actionName](processApi.storeId, this.props.processIds, this.props.processDefinitionIds);
	}

	buildToolboxButtonProps(actionName, buttonIcon, buttonStyle, otherProps={}) {
		let buttonProps, buttonLabel;
		buttonStyle = buttonStyle || 'primary';
		buttonLabel = Realize.i18n.t(`activity.toolbox.${actionName}`);
		buttonProps = Object.assign({
			title: buttonLabel,
			tooltipText: buttonLabel,
			tooltipPosition: 'bottom',
			icon: buttonIcon,
			style: buttonStyle,
			disabled: this.props.waitingForAction,
			onClick: this.executeToolboxAction.bind(this, actionName),
			className: actionName
		}, otherProps);

		if(!this.props.isMobile && window.innerWidth <= 900) {
			buttonProps.name = buttonLabel;
		}

		return buttonProps;
	}

	getDesktopButtonsProps() {
		const buttonsProps = [
			this.buildPrintFormButtonProps(),
			this.buildMarkActivityAsUnreadProps(),
			this.buildHelpButtonProps(),
			this.buildAssignActivityToUserButtonProps(),
			this.buildSaveButtonProps(),
			this.buildTimeLineButtonProps()
		];

		if(this.props.existHelpFile)
			buttonsProps.splice(3, 0, this.buildDownloadProcessHelpFileButtonProps());

		return buttonsProps;
	}

	getMobileButtonsProps(){
		return [
			this.buildMarkActivityAsUnreadProps(),
			this.buildAssignActivityToUserButtonProps(),
			this.buildSaveButtonProps()
		];
	}


	buildMarkActivityAsUnreadProps() {
		return this.buildToolboxButtonProps('markActivityAsUnread', 'bookmark', {}, {'aria-label': Realize.i18n.t(`activity.toolbox.markActivityAsUnread`)})
	}

	buildSaveButtonProps() {
		return this.buildToolboxButtonProps('saveActivity', 'save', {}, {'aria-label': Realize.i18n.t(`activity.toolbox.saveActivity`)});
	}

	buildHelpButtonProps() {
		return this.buildToolboxButtonProps('openProcessHelpModal', 'help', {}, {'aria-label': Realize.i18n.t(`activity.toolbox.openProcessHelpModal`)});
	}

	buildTimeLineButtonProps() {
		return this.buildToolboxButtonProps('openTimeLine', 'timeline', {}, {'aria-label': Realize.i18n.t(`activity.toolbox.openTimeLine`)});
	}

	buildDownloadProcessHelpFileButtonProps() {
		return this.buildToolboxButtonProps('downloadProcessHelpFile', 'live_help', {}, {'aria-label': Realize.i18n.t(`activity.toolbox.downloadProcessHelpFile`)});
	}

	buildAssignActivityToUserButtonProps() {
		return this.buildToolboxButtonProps('openAssignActivityToUserModal', 'arrow_forward', {}, {'aria-label': Realize.i18n.t(`activity.toolbox.openAssignActivityToUserModal`)});
	}

	buildPrintFormButtonProps() {
		return this.buildToolboxButtonProps('printForm', 'print', {}, {'aria-label': Realize.i18n.t(`activity.toolbox.printForm`)});
	}

	buildToolboxButtonsProps() {
		const isMobile = this.props.isMobile;

		return (isMobile === true)
		? this.getMobileButtonsProps()
		: this.getDesktopButtonsProps();
	}

	buildReadOnlyToolboxButtonsProps() {
		ActivityFormEventHandler.publish(ActivityFormEvents.READ_ONLY_TOOLBOX_BUTTONS);
		return [
			this.buildPrintFormButtonProps(),
			this.buildHelpButtonProps()
		];
	}

	getToolboxButtons() {		
		return (this.props.readOnly)
		? this.buildReadOnlyToolboxButtonsProps()
		: this.buildToolboxButtonsProps();
	}

	renderDropdownButton() {
		let buttonsProps = this.getToolboxButtons();
			buttonsProps = buttonsProps.map(function(button) {
			button.name = button.title;
			delete button.icon;
			return button;
		});

		return (
			<DropdownButton actions={buttonsProps} name={Realize.i18n.t(`activity.toolbox.${"toolboxName"}`)} />
		);
	}

	renderButtonGroup() {
		return (
			<ButtonGroup buttons={this.getToolboxButtons()} />
		);
	}

	detectMob() { 
		if( navigator.userAgent.match(/Android/i)
			|| navigator.userAgent.match(/webOS/i)
			|| navigator.userAgent.match(/iPhone/i)
			|| navigator.userAgent.match(/iPad/i)
			|| navigator.userAgent.match(/iPod/i)
			|| navigator.userAgent.match(/BlackBerry/i)
			|| navigator.userAgent.match(/Windows Phone/i)
		){
			 return true;
		}
		return false;		
	}

	detectMobWidth() {
		if(this.state && this.state.winparent){
			if(this.state.width && this.state.width <= 900) return true;
			return false;
		} 

		if(window.innerWidth <= 900) {
			return true;
		}

		return false;		
 }

	render() {		
		const isMobile = this.props.isMobile || this.detectMob() || this.detectMobWidth();

		return (isMobile === true)
		? this.renderDropdownButton()
		: this.renderButtonGroup();
	}
}
